// Haptics (design 10 §8): short, clear pulses for the player's own physical acts and the table's big moments,
// timed to what the screen shows; never for the routine (opponents' discards, draws, the deal). The web gives
// them only on Android (Chrome's navigator.vibrate, after the page's first tap); Safari has none.

import type { View } from "./view";

/** A pulse (ms), or a pattern of pulses and pauses, on a touch device that has them. */
export function pulse(pattern: number | readonly number[]): void {
  if (typeof navigator === "undefined" || typeof navigator.vibrate !== "function") return;
  if (typeof matchMedia === "function" && !matchMedia("(pointer: coarse)").matches) return;   // a mouse: no motor
  try {
    navigator.vibrate(typeof pattern === "number" ? pattern : [...pattern]);
  } catch {
    // refused (no tap yet): nothing to do
  }
}

/** The pulses of design 10 §8: your tile landing, your call, a win, and your clock's last seconds beginning (as a call's). */
export const PULSE = { land: 12, call: [10, 40, 10], win: 30 } as const;

/** The pulse that going from `prev` to `next` calls for: once for each callout, and none for one that was already there, as a table
 *  opened or a tab come back would otherwise have it. */
export function pulseFor(prev: View, next: View): number | readonly number[] | null {
  if (next.gameId !== prev.gameId || next.hand?.index !== prev.hand?.index) return null;
  const c = next.callout;
  if (!c || c.seq === prev.callout?.seq) return null;
  if (c.action === "RON" || c.action === "TSUMO") return PULSE.win;
  return c.seat === next.seat ? PULSE.call : null;
}
